<template>
<div class="chapter">
<div class="inner_page">
<p><span epub:type="pagebreak" id="pageiii" title="iii"></span></p>
<div class="photo50"><img alt="Title Page: Understanding Postmodernism: A Christian Perspective: Stewart E. Kelly With James K. Dew Jr." class="img100" src="Images/tp_art.png"/></div>
<p class="first"><br/></p>
<p class="firstcenter"><a href="http://www.ivpacademic.com" target="_blank"><img alt="IVP Academic Imprint" src="Images/IVPAcademic.png"/></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_titlepage.vue?7a48acfb